import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthAntiGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        return new Promise((resolve, reject) => {
            this.authService.validateSession()
                .then((data) => {
                    this.router.navigate(['home']);
                    reject(false);
                })
                .catch(error => {
                    window.scroll(0, 0);
                    resolve(true);
                });
        });
    }
}
